// Phase 5 (UI polish) — single source of truth for the chart color palette and the repeated
// chart-card wrapper style previously duplicated (with drift risk) across every report tab.
export const CHART_COLORS = ['#0066CC', '#00A600', '#FF9900', '#CC0000', '#4b286d', '#6F4D7C'];

export const chartCardStyle = {
  background: '#fff',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  borderRadius: '8px',
  border: '1px solid #e4e4e4'
};

export default CHART_COLORS;
